// Inline WhatsApp glyph (lucide-react has no dedicated icon)
export const WhatsAppIcon = ({ className = "h-5 w-5", ...props }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M19.11 17.49c-.27-.14-1.61-.79-1.86-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.17-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.42.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.47-.84-2.02-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.3 0 1.36.98 2.67 1.12 2.85.14.18 1.93 2.95 4.68 4.13.65.28 1.16.45 1.56.58.66.21 1.26.18 1.73.11.53-.08 1.61-.66 1.84-1.3.23-.64.23-1.18.16-1.3-.07-.12-.25-.18-.52-.32zM12.04 2C6.55 2 2.09 6.46 2.09 11.95c0 1.94.55 3.76 1.49 5.29L2 22l4.92-1.55c1.47.81 3.16 1.27 4.96 1.27 5.49 0 9.95-4.46 9.95-9.95C21.83 6.46 17.53 2 12.04 2z"/>
  </svg>
);

export default WhatsAppIcon;
